import React from 'react';
import { CheckCircle2, Clock, Calendar, Video, BookOpen, Users, ArrowRight } from 'lucide-react';
import { DarkCard, LightCard, CheckListItem } from '../components/Cards';
export function ProgramulRise() {
  return <div className="bg-rise-white min-h-screen" data-id="element-913" data-mp="3gkftn6rjjdjj">
      {/* 1. Hero Section */}
      <section className="bg-rise-black text-rise-white py-12 md:py-20 px-6 relative overflow-hidden" data-id="element-914" data-mp="3br3inzfsb599">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-915" data-mp="3pii40cx5zijh">
          <div className="absolute top-[-20%] right-[-10%] w-[50%] h-[100%] bg-rise-gold/5 blur-[120px] rounded-full" data-id="element-916" data-mp="3lgwjc5ee1zyq"></div>
        </div>
        <div className="max-w-rise-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center relative z-10" data-id="element-917" data-mp="3a8nz7954r69">
          {/* Text Content */}
          <div className="flex flex-col items-center text-center order-1" data-id="element-918" data-mp="254r4c8qte2fk">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-919" data-mp="2054sa2mq2s8c">
              PROGRAM DE 12 SĂPTĂMÂNI
            </div>
            <h1 className="font-playfair text-[36px] md:text-[52px] leading-tight mb-6" data-id="element-920" data-mp="3cq0oquf0dx6p">
              Programul R.I.S.E.
            </h1>

            {/* Photo on mobile only */}
            <div className="lg:hidden relative mb-8 w-full max-w-[280px] mx-auto" data-id="element-921" data-mp="3lhsskm9j282b">
              <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-3 translate-y-3 pointer-events-none" data-id="element-922" data-mp="3qgm9koo0wh78"></div>
              <img src="https://cdn.magicpatterns.com/uploads/pG12JLChzvmkcCf8uS9D97/Teodora_1.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-923" data-mp="3ve5m9k52olx2" />
            </div>

            <p className="font-dm-sans text-[19px] text-rise-white/80 max-w-xl mx-auto leading-relaxed mb-10" data-id="element-924" data-mp="261kaewv9gfi0">
              Realitate • Identitate • Stabilitate • Evoluție. Un parcurs
              transformator de 3 luni pentru a-ți reconstrui fundația interioară
              și a trăi o viață aliniată cu adevăratul tău potențial.
            </p>
            <div className="flex justify-center w-full" data-id="element-925" data-mp="38g9sdocb21no">
              <a href="#inscriere" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors flex items-center justify-center gap-2 w-full max-w-md" data-id="element-926" data-mp="3mehj3eir06qe">
                Vreau să mă înscriu <ArrowRight size={18} data-id="element-927" data-mp="3rc9n36wo3jay" />
              </a>
            </div>
          </div>

          {/* Photo on desktop only */}
          <div className="relative hidden lg:block w-full max-w-md mx-auto lg:ml-auto order-2" data-id="element-928" data-mp="9y4700jhrzpb">
            <div className="absolute inset-0 border border-rise-gold/70 rounded-xl translate-x-5 translate-y-5 pointer-events-none" data-id="element-929" data-mp="4zb1auag5czp"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pG12JLChzvmkcCf8uS9D97/Teodora_1.jpg" alt="Teodora Trifu" className="w-full h-auto aspect-[4/5] object-cover rounded-xl shadow-lg relative z-10" data-id="element-930" data-mp="dyekrzdizueq" />
          </div>
        </div>
      </section>

      {/* 2. Pentru cine este */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-931" data-mp="oigs1z772kne">
        <div className="max-w-rise-content mx-auto" data-id="element-932" data-mp="sjtwq5yjwhsq">
          <div className="text-center mb-16" data-id="element-933" data-mp="smof7ry07sji">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-934" data-mp="esx3ccwsvwkm">
              Acest program este pentru tine dacă:
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-935" data-mp="4vanno7og0zl">
            <LightCard title="Te simți blocat" data-id="element-936" data-mp="4wu1l85v1zy7">
              <ul className="space-y-4" data-id="element-937" data-mp="9tkghs5xipi1">
                <CheckListItem data-id="element-938" data-mp="9udi6eq16otb">
                  Simți că trăiești pe pilot automat și zilele trec fără sens.
                </CheckListItem>
                <CheckListItem data-id="element-939" data-mp="t5v6ssytaej">
                  Ai atins obiective externe (carieră, relații), dar interior
                  simți un gol.
                </CheckListItem>
                <CheckListItem data-id="element-940" data-mp="3ozygc4glc0bw">
                  Te confrunți cu anxietate, stres cronic sau burnout.
                </CheckListItem>
                <CheckListItem data-id="element-941" data-mp="3f7snksiilevn">
                  Îți este greu să iei decizii sau să pui limite sănătoase.
                </CheckListItem>
              </ul>
            </LightCard>
            <LightCard title="Îți dorești o schimbare" data-id="element-942" data-mp="367md7fi44v0p">
              <ul className="space-y-4" data-id="element-943" data-mp="3697ahcvtas29">
                <CheckListItem data-id="element-944" data-mp="318jd89gzpezl">
                  Vrei să te cunoști mai bine și să îți înțelegi tiparele.
                </CheckListItem>
                <CheckListItem data-id="element-945" data-mp="2wahu5ojkdfo4">
                  Ești pregătit să îți asumi responsabilitatea pentru viața ta.
                </CheckListItem>
                <CheckListItem data-id="element-946" data-mp="2sa7o6bvrup99">
                  Cauți instrumente practice pentru gestionarea emoțiilor.
                </CheckListItem>
                <CheckListItem data-id="element-947" data-mp="qg8e1tudydy5">
                  Îți dorești relații mai autentice și o viață cu sens.
                </CheckListItem>
              </ul>
            </LightCard>
          </div>
        </div>
      </section>

      {/* 3. Ce vei obține */}
      <section className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-948" data-mp="2db3fj7g99rl2">
        <div className="max-w-rise-content mx-auto" data-id="element-949" data-mp="2i4pvb8hpubl3">
          <div className="text-center mb-16" data-id="element-950" data-mp="2m61bknep9kgm">
            <div className="inline-block font-dm-sans text-[13px] tracking-[0.15em] uppercase text-rise-white border border-rise-gold/50 rounded-full px-5 py-2 mb-6" data-id="element-951" data-mp="2m4q86op62eq1">
              BENEFICII
            </div>
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-952" data-mp="1ugg41r1qgvmk">
              Ce vei obține în urma programului
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-953" data-mp="23g35gcugq1fm">
            <DarkCard title="Claritate Mentală" icon={<CheckCircle2 size={32} data-id="element-955" data-mp="39uu92oaz00dc" />} data-id="element-954" data-mp="39v41eijhmjm7">
              Vei învăța să îți liniștești mintea, să reduci zgomotul mental și
              să iei decizii din spațiul tău de putere interioară, nu din frică.
            </DarkCard>
            <DarkCard title="Stabilitate Emoțională" icon={<CheckCircle2 size={32} data-id="element-957" data-mp="1asotcjvlrd30" />} data-id="element-956" data-mp="1aqm3q0yd3lyt">
              Vei dobândi instrumente pentru a naviga emoțiile dificile fără a
              te lăsa copleșit de ele, construind o reziliență emoțională
              solidă.
            </DarkCard>
            <DarkCard title="Aliniere Autentică" icon={<CheckCircle2 size={32} data-id="element-959" data-mp="r2mvawr9sqwk" />} data-id="element-958" data-mp="w2hl0wzb7ag1">
              Vei descoperi cine ești cu adevărat dincolo de condiționări și vei
              începe să trăiești în aliniere cu valorile și dorințele tale
              profunde.
            </DarkCard>
          </div>
        </div>
      </section>

      {/* 4. Structura */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-960" data-mp="d9wxzw6ajzk5">
        <div className="max-w-rise-content mx-auto" data-id="element-961" data-mp="8c54wytwu7ed">
          <div className="text-center mb-16" data-id="element-962" data-mp="8bc5kixa6k69">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-963" data-mp="2jzh1m5u8ediy">
              Structura Programului (12 Săptămâni)
            </h2>
            <p className="font-dm-sans text-[19px] text-rise-gray max-w-2xl mx-auto" data-id="element-964" data-mp="2or8h9lbumyub">
              Un parcurs pas cu pas, împărțit în 4 etape esențiale.
            </p>
          </div>

          <div className="space-y-8" data-id="element-965" data-mp="2f0nm67vdwcg5">
            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-966" data-mp="32pozo9j2qdsa">
              <div className="md:w-1/4 shrink-0" data-id="element-967" data-mp="37pbdol6q7y25">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-968" data-mp="37o07yftq0g8e">
                  Modulul 1
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-969" data-mp="2ynv3adfwvvxx">
                  Săptămânile 1-3
                </div>
              </div>
              <div data-id="element-970" data-mp="1ic7wmbs9y331">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-971" data-mp="1n8okr5zh4hg4">
                  Realitate: Acceptarea prezentului
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-972" data-mp="2e0kz0758ymm7">
                  Începem prin a face un audit onest al vieții tale actuale.
                  Învățăm să privim realitatea fără filtre, să identificăm
                  mecanismele de apărare și să ieșim din starea de negare sau
                  victimizare.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-973" data-mp="2xm7l6lzjsl5l">
              <div className="md:w-1/4 shrink-0" data-id="element-974" data-mp="2sqa7knfo5swi">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-975" data-mp="2nw60832hriuw">
                  Modulul 2
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-976" data-mp="2iwa56tbrv1rh">
                  Săptămânile 4-6
                </div>
              </div>
              <div data-id="element-977" data-mp="3bl7dq4q6lk71">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-978" data-mp="3bkp9aktd7zo1">
                  Identitate: Cine ești tu, de fapt?
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-979" data-mp="3ny2m4nbxho9f">
                  Explorăm credințele limitative, tiparele moștenite și rănile
                  emoționale. Separăm vocea autentică de vocile celorlalți și
                  reconstruim o imagine de sine sănătoasă și puternică.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-980" data-mp="aq7w2ubtd061">
              <div className="md:w-1/4 shrink-0" data-id="element-981" data-mp="fi976cx8wkuh">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-982" data-mp="fjkakbms3ql2">
                  Modulul 3
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-983" data-mp="pg6vf0f3uhn3">
                  Săptămânile 7-9
                </div>
              </div>
              <div data-id="element-984" data-mp="2h0jqlpbh8rm6">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-985" data-mp="2h11k4e6r8rqe">
                  Stabilitate: Crearea ancorelor interioare
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-986" data-mp="2lx0d6f312xx5">
                  Construim practici zilnice pentru reglarea sistemului nervos.
                  Învățăm să setăm limite sănătoase, să gestionăm stresul și să
                  ne creăm un spațiu interior de siguranță la care să ne putem
                  întoarce oricând.
                </p>
              </div>
            </div>

            <div className="flex flex-col md:flex-row gap-6 bg-white p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-987" data-mp="39p77l8p70utx">
              <div className="md:w-1/4 shrink-0" data-id="element-988" data-mp="3eoa8qi21ygwm">
                <div className="text-rise-gold font-playfair text-[24px] font-bold mb-2" data-id="element-989" data-mp="3elo52tia8ljo">
                  Modulul 4
                </div>
                <div className="text-rise-black font-semibold uppercase tracking-wider text-[14px]" data-id="element-990" data-mp="1k97q94bf7z37">
                  Săptămânile 10-12
                </div>
              </div>
              <div data-id="element-991" data-mp="1801m59wkj76v">
                <h3 className="font-playfair text-[24px] text-rise-black mb-3" data-id="element-992" data-mp="17zi29nncy8q7">
                  Evoluție: Integrare și acțiune aliniată
                </h3>
                <p className="font-dm-sans text-[16px] text-rise-gray leading-relaxed" data-id="element-993" data-mp="12yc7zle1udek">
                  Trecem de la teorie la practică. Definim o viziune clară
                  pentru viitor și creăm un plan de acțiune sustenabil, bazat pe
                  noua ta fundație interioară.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Ce include */}
      <section className="py-12 md:py-20 px-6 bg-rise-black text-rise-white" data-id="element-994" data-mp="1gsbwqsbdleon">
        <div className="max-w-rise-content mx-auto" data-id="element-995" data-mp="1gufyb3lsy1lr">
          <div className="text-center mb-16" data-id="element-996" data-mp="ad2iugbdf100">
            <h2 className="font-playfair text-[32px] md:text-[42px] mb-4" data-id="element-997" data-mp="a9n63k56641r">
              Ce este inclus în program
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-998" data-mp="2tjww8zavh223">
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-999" data-mp="2xkyxflocno6p">
              <Video className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1000" data-mp="2jlh3yt03zmr0" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1001" data-mp="2ojsc8zar9p74">
                12 Module Video
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1002" data-mp="29v4j0zodtrkc">
                Lecții înregistrate pe care le poți parcurge în ritmul tău.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1003" data-mp="20u6i4q98q05z">
              <BookOpen className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1004" data-mp="25t194fhd2v16" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1005" data-mp="25r6ol2a054xm">Caiet de Lucru</h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1006" data-mp="1qwjvfhlp94bg">
                Exerciții practice, jurnale și teme de reflecție pentru fiecare
                modul.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1007" data-mp="1cbe56meos1xc">
              <Users className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1008" data-mp="189szpm4hepx6" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1009" data-mp="1m92dkf57t7xz">
                6 Sesiuni Live Q&A
              </h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1010" data-mp="1h73911xqo4zg">
                Întâlniri de grup bilunare pentru suport și clarificări.
              </p>
            </div>
            <div className="bg-rise-anthracite p-6 rounded-xl border border-rise-gold/20 text-center" data-id="element-1011" data-mp="1r62k0r5z8cpm">
              <Clock className="text-rise-gold mx-auto mb-4" size={32} data-id="element-1012" data-mp="24xh4l2fj8lys" />
              <h3 className="font-playfair text-[20px] mb-2" data-id="element-1013" data-mp="1zymd7c3i1p32">Acces pe Viață</h3>
              <p className="font-dm-sans text-[15px] text-rise-white/70" data-id="element-1014" data-mp="2evn45ddv9g0h">
                Păstrezi accesul la toate materialele și actualizările viitoare.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6. Testimoniale (Short) */}
      <section className="py-12 md:py-20 px-6 bg-rise-white" data-id="element-1015" data-mp="78ka2f27wctg">
        <div className="max-w-rise-content mx-auto" data-id="element-1016" data-mp="c86mima81p17">
          <div className="text-center mb-16" data-id="element-1017" data-mp="h0horvsfpmwx">
            <h2 className="font-playfair text-[32px] md:text-[42px] text-rise-black mb-4" data-id="element-1018" data-mp="h0q1nnok4s84">
              Experiențele participanților
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1019" data-mp="3khga097m3hcz">
            <LightCard title="O transformare reală" data-id="element-1020" data-mp="3kjazm0ttvxne">
              <p className="italic mb-4" data-id="element-1021" data-mp="3pgsxmw6b4sgm">
                "Acest program mi-a schimbat complet perspectiva asupra vieții.
                Am învățat să mă ascult, să pun limite și să nu mă mai simt
                vinovată pentru că îmi doresc mai mult de la viață. Structura
                este excelentă!"
              </p>
              <div className="font-semibold text-rise-black" data-id="element-1022" data-mp="19olsibrg3pwz">Maria D.</div>
            </LightCard>
            <LightCard title="Am regăsit liniștea" data-id="element-1023" data-mp="1em5bfoz38qv9">
              <p className="italic mb-4" data-id="element-1024" data-mp="2z6adyrg7i0yx">
                "După ani de terapie, simțeam că înțeleg mental problemele, dar
                nu știam cum să le rezolv practic. Programul R.I.S.E. mi-a
                oferit exact instrumentele de care aveam nevoie pentru a face
                schimbarea."
              </p>
              <div className="font-semibold text-rise-black" data-id="element-1025" data-mp="2kgbk30vopbp9">Elena S.</div>
            </LightCard>
          </div>
        </div>
      </section>

      {/* 7. Investitie */}
      <section id="inscriere" className="py-12 md:py-20 px-6 bg-rise-anthracite text-rise-white" data-id="element-1026" data-mp="2bfwu3o7rz8ff">
        <div className="max-w-3xl mx-auto text-center" data-id="element-1027" data-mp="26iemq29ep19j">
          <h2 className="font-playfair text-[32px] md:text-[42px] mb-6" data-id="element-1028" data-mp="21i8pm6kdamk2">
            Investiția în evoluția ta
          </h2>
          <div className="bg-rise-black border border-rise-gold/40 rounded-2xl p-8 md:p-12 relative overflow-hidden" data-id="element-1029" data-mp="4q8hov2zj24b">
            <div className="absolute top-0 left-0 w-full h-1 bg-rise-gold" data-id="element-1030" data-mp="3vxl17grcbrne"></div>
            <div className="flex flex-col items-center gap-2 mb-2" data-id="element-1031" data-mp="1u6u8crrayql2">
              <div className="flex items-baseline justify-center gap-3 flex-wrap" data-id="element-1032" data-mp="1yxu7m3nw9kqq">
                <span className="text-[24px] md:text-[28px] text-rise-white/50 line-through font-playfair" data-id="element-1033" data-mp="1yznf1l6c08zs">
                  1.200 lei
                </span>
                <span className="text-[44px] md:text-[52px] font-playfair text-rise-gold leading-none" data-id="element-1034" data-mp="1p8ss0el9h5da">
                  699 lei
                </span>
              </div>
              <p className="inline-block bg-rise-gold/15 text-rise-gold border border-rise-gold/40 rounded-full px-4 py-1 mt-2 font-dm-sans text-[12px] font-bold uppercase tracking-wider" data-id="element-1035" data-mp="2hx85gwoqvfmi">
                Preț special
              </p>
            </div>
            <p className="font-dm-sans text-[16px] text-rise-white/70 mb-8 mt-4" data-id="element-1036" data-mp="27wo1hm9ubx0l">
              Plată unică sau în 2 rate egale
            </p>
            <ul className="text-left space-y-4 mb-8 max-w-md mx-auto" data-id="element-1037" data-mp="wjvaidovjcll">
              <CheckListItem data-id="element-1038" data-mp="wgzdcrkuory7">
                Acces complet la cele 12 module video
              </CheckListItem>
              <CheckListItem data-id="element-1039" data-mp="35sa4zgzi5ap9">Caiet de lucru digital (PDF)</CheckListItem>
              <CheckListItem data-id="element-1040" data-mp="35u4dfvtl7acg">Acces la cele 6 sesiuni live de Q&A</CheckListItem>
              <CheckListItem data-id="element-1041" data-mp="3jr9ibshke364">Grup privat de suport pe WhatsApp</CheckListItem>
              <CheckListItem data-id="element-1042" data-mp="3fr95gca46016">Acces pe viață la materiale</CheckListItem>
            </ul>

            <div className="flex justify-center" data-id="element-1043" data-mp="2rztyu7bb0wk4">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors inline-block w-full md:w-auto" data-id="element-1044" data-mp="2ryiw8atlhuul">
                Înscrie-te Acum
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 8. Final CTA (Light) */}
      <section className="py-14 md:py-24 px-6 bg-rise-white text-center relative overflow-hidden" data-id="element-1045" data-mp="2t5tn1kvi3ncr">
        <div className="absolute inset-0 opacity-30 pointer-events-none flex items-center justify-center" data-id="element-1046" data-mp="2y4myl7r894aa">
          <div className="w-[800px] h-[800px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1047" data-mp="326rsm7ll82xg"></div>
          <div className="w-[600px] h-[600px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1048" data-mp="3764eoq4mx5yz"></div>
          <div className="w-[400px] h-[400px] border-[1px] border-rise-gold/40 rounded-full absolute" data-id="element-1049" data-mp="3c5h8jutxbdb2"></div>
        </div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-1050" data-mp="3h2hdg2f1ea0l">
          <h2 className="font-playfair text-[32px] md:text-[48px] text-rise-black mb-6" data-id="element-1051" data-mp="3luqyb41aojw0">
            Ești pregătit să începi transformarea?
          </h2>
          <p className="font-dm-sans text-[19px] text-rise-gray mb-10" data-id="element-1052" data-mp="3pvax0c1invk9">
            Nu mai amâna momentul în care alegi să trăiești o viață aliniată cu
            adevăratul tău potențial.
          </p>
          <div className="flex justify-center" data-id="element-1053" data-mp="3mruhsrnpf63">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZvTY3b9zlXihtr5N7rytBUsvVV4lTYHjzoiEOGqKUeKSdVw/viewform" target="_top" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[16px] transition-colors" data-id="element-1054" data-mp="dt2vo1kbkqei">
              Vreau să mă înscriu
            </a>
          </div>
        </div>
      </section>
    </div>;
}